<template>
  <transition>
    <div
      ref="notification"
      class="m-notification-bar"
      :class="{ 'is-active' : isActive, 'is-visible' : isVisible }"
      :style="{ '--notification-height' : notificationHeightProp }"
      v-show="isActive"
    >
      <div class="m-notification-bar__inner">
        <div
          class="m-notification-bar__message"
          v-html="
            countdownActive && countdownSeconds > 0
              ? computedCountdownText
              : text
          "
        ></div>

        <button @click="close" class="m-notification-bar__close">
          <span class="m-notification-bar__close-label" v-text="$t('close')"></span>
          <svg class="m-notification-bar__close-icon" aria-hidden="true">
            <use :xlink:href="$root.spritePath + '#close'" />
          </svg>
        </button>
      </div>
    </div>
  </transition>
</template>
<script>
import Cookies from 'js-cookie'
export default {
  props: {
    text: {
      type: String,
      default: '',
    },
    countdownActive: {
      type: Boolean,
      default: false,
    },
    countdownUntil: {
      type: String,
      default: null,
    },
    countdownText: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      notificationHeightProp: null,
      isActive: false,
      isVisible: false,
      countdownInterval: null,
      countdownSeconds: this.countdownUntil
        ? (Date.parse(this.countdownUntil) - Date.parse(new Date())) / 1000
        : 0,
    }
  },

  computed: {
    computedCountdownText() {
      const seconds = Math.floor(this.countdownSeconds % 60);
      const minutes = Math.floor((this.countdownSeconds / 60) % 60);
      const hours = Math.floor((this.countdownSeconds / (60 * 60)) % 24);
      const days = Math.floor(this.countdownSeconds / (60 * 60 * 24));

      let formatted = [];
      if (days > 0) {
        formatted.push(days + ' ' + (days > 1 ? this.$t('countdown.days') : this.$t('countdown.day')));
      }

      if (days === 0) {
        if (hours > 0) {
          formatted.push(hours + ' ' + (hours > 1 ? this.$t('countdown.hours') : this.$t('countdown.hour')));
        }

        if (hours <= 3) {
          if (minutes > 0) {
            formatted.push(minutes + ' ' + (minutes > 1 ? this.$t('countdown.minutes') : this.$t('countdown.minute')));
          }
        }

        if (hours === 0) {
          if (minutes === 0) {
            formatted.push(seconds + ' ' + (seconds > 1 ? this.$t('countdown.seconds') : this.$t('countdown.second')));
          }
        }
      }

      // Join with comma's and add a " and " for the last part when needed.
      const combined = formatted.length === 1
        ? formatted.join('')
        : formatted.slice(0, formatted.length - 1).join(', ') + ' ' + this.$t('countdown.and') + ' ' + formatted[formatted.length - 1];

      return this.countdownText.replace('[countdown]', combined);
    },
  },

  created() {
    var cookie = Cookies.get('bijvrijdag_notify');
    if (cookie !== 'closed') {
      this.open();
    }
  },

  mounted() {
    if (this.countdownSeconds) {
      this.countdownInterval = setInterval(() => {
        this.countdownSeconds--;
      }, 1000);
    }
  },

  unmounted() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  },

  methods: {
    open() {
      this.isActive = true;
      this.$nextTick(() => this.positionHeader());

      window.addEventListener('resize', this.setNotificationHeightProp, { passive: true });
    },

    close() {
      this.isActive = false;
      Cookies.set('bijvrijdag_notify', 'closed', 1, "/"); // Save cookie for 1 day

      window.removeEventListener('resize', this.setNotificationHeightProp, { passive: true });
    },

    toggle() {
      this.isActive ? this.close() : this.open();
    },

    setNotificationHeightProp() {
      document.documentElement.style.setProperty('--notification-height', this.$refs.notification.clientHeight + "px");
    },

    positionHeader() {
      this.setNotificationHeightProp();
      this.observer = new IntersectionObserver(entries => {
        const elHalf = (entries[0].boundingClientRect.height / 2);
        let elTopPos = entries[0].boundingClientRect.y * -1;

        if (elTopPos <= elHalf) {
          this.isVisible = true;
        } else {
          this.isVisible = false;
        }
      }, {
        threshold: [0, 0.5, 1],
      });
      this.observer.observe(this.$refs.notification);
    },
  },
}
</script>
